export const SNACKBAR = {
	SUCCESS: 'success-snackbar',
	SUCCESS_MULTILINE: 'success-multiline-snackbar',
	WARNING: 'warning-snackbar',
	ERROR: 'error-snackbar',
	INFO: 'info-snackbar',
	ERROR_MULTILINE: 'error-multiline-snackbar',
	DURATION: 3000,
	ACTION: '',
	SNACKBAR_POSITION_TOP: 'top',
	CUSTOM_SNACKBAR_DURATION: 5000,
};
